import { useNavigate, useSearchParams } from 'react-router-dom'

import s from './SceneCard.module.scss'

import { SceneGET } from 'types/scenes'

import { getIconByMetaverse } from 'constants/MetaverseIcons'

import { useModal } from 'hooks/useModal'
import { useShowDropdown } from 'hooks/useShowDropdown'

import { DeleteIcon } from 'assets/icons/DeleteIcon'
import { EditIcon } from 'assets/icons/EditIcon'
import { HeatmapIcon } from 'assets/icons/HeatmapIcon'
import { ImageIcon } from 'assets/icons/ImageIcon'
import { InfoIcon } from 'assets/icons/InfoIcon'

import { Card } from 'components/UI/Card/Card'
import ConfirmMessage from 'components/UI/ConfirmMessage'
import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import { Dropmenu } from 'components/UI/Dropmenu/Dropmenu'

interface Props {
  scene: SceneGET
  handleDelete: (id: number) => void
}

export const SceneCard = (props: Props) => {
  const { scene, handleDelete } = props
  const { ref, showDropdown } = useShowDropdown()
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()
  const { show, handleClose, handleOpen } = useModal()

  const openInfoModal = () => {
    navigate(`${scene.id}/?${searchParams}`)
  }

  const openEditForm = () => {
    navigate(`edit/${scene.id}/?${searchParams}`)
  }

  return (
    <>
      <Card variant="primary" className={s.cardWrapper} onClick={openInfoModal}>
        <Card.Image height='14.063rem'>
          <img src={getIconByMetaverse(scene.metaverse)} alt="" className={s.metaLogo} />
          {scene?.preview_file ? (
            <img src={scene?.preview_file} alt="Preview" />
          ) : (
            <div className={s.previewFallbackWrapper}>
              <ImageIcon className={s.previewFallback} />
              <p className={s.previewFallbackText}>No preview image</p>
            </div>
          )}
        </Card.Image>
        <Card.Info className={s.cardInfo}>
          <div className={s.footer}>
            <Card.CroppedText>{scene?.name}</Card.CroppedText>
            <Card.CroppedText className={s.footerCoords}>{scene?.coords}</Card.CroppedText>
          </div>
          <div className={s.buttonsWrapper}>
            <CustomButton
              variant="primary"
              onClick={(e) => {
                e.stopPropagation()
                navigate(`heatmap/${scene.id}`)
              }}
            >
              <HeatmapIcon className={s.heatmapIcon} />
            </CustomButton>
            <Dropmenu
              variant="primary"
              show={showDropdown}
              cref={ref}
              items={[
                { icon: <InfoIcon />, title: 'Show Info', onClick: openInfoModal },
                { icon: <EditIcon />, title: 'Edit', onClick: openEditForm },
                { icon: <DeleteIcon />, title: 'Delete', onClick: handleOpen, hide: !scene.scene_file },
              ]}
            />
          </div>
        </Card.Info>
      </Card>
      <>
        <ConfirmMessage
          isOpen={show}
          handleClose={handleClose}
          message={`Are you sure you want to delete the "${scene.name}" Scene file?`}
          deleteItem={handleDelete}
          id={scene.id}
        />
      </>
    </>
  )
}
